<template>
  <ArticleDetail
    :article="article"
    :loading="loading"
    :url-share="urlShare"
    :breadcrumbs="breadcrumbs"
    :report-version-open="true"
    :share-networks="shareNetworks"
    :report-versions="reportVersions"
    :content-text-share="contentTextShare"
  />
</template>

<script setup>
import { STRUCTURED_DATA_TYPE } from '@/utils/enums';
import ArticleDetail from '@/components/Details/Article';

const route = useRoute();
const store = useStore();
const { createHeadSeo } = useHeadSeo();
const {
  loading,
  urlShare,
  breadcrumbs,
  shareNetworks,
  verifySection,
  reportVersions,
  contentTextShare
} = useArticleDetail();

const { data: article } = await useAsyncData(
  `articleDetailMarket_${route.params.slug}`,
  async () => await store.dispatch('strapi/getArticleBySlug', { slug: route.params.slug })
);

verifySection(article.value);

const { meta_title: metaTitle, abstract, main_image: mainImage, og_image: ogImage } = article.value;
const imgUrl = ogImage?.url ?? mainImage?.url;

createHeadSeo(metaTitle, abstract, imgUrl, article.value, STRUCTURED_DATA_TYPE.ARTICLE);
</script>
